import {ReactNode} from 'react';
import {Navigate, useParams} from 'react-router-dom';
import {PATHS} from 'routes/constants';
import {getDocumentType, useIVStore} from '@chekin/shared';

type IVDocumentTypeGuardProps = {
  children: ReactNode;
};

function IVDocumentTypeGuard({children}: IVDocumentTypeGuardProps) {
  const {id} = useParams();
  const documentType = useIVStore(getDocumentType);

  if (!documentType) {
    return <Navigate to={`../../${PATHS.verification.main}/${id ?? ''}`} replace />;
  }

  return <>{children}</>;
}

export {IVDocumentTypeGuard};
